import React from 'react';
import { Divider } from '@mui/material';
import { useDispatch } from 'react-redux';
import { UnknownAction } from '@reduxjs/toolkit';
import { PlaceholderGrid, CutOffIcon } from '../../../../styles/globalStyles';
import exerciseIcon from '../../../../assets/icons/exerciseIcon.svg';
import {
  SwitchStyled,
  SelectionBoxStyled,
  SelectionTitleStyled
} from './style';

export const Selection = ({
  selection,
  handleSelectionToggle
}: {
  selection: { stressFactor: boolean; activityFactor: boolean };
  handleSelectionToggle: (selection: {
    stressFactor: boolean;
    activityFactor: boolean;
  }) => UnknownAction;
}) => {
  const dispatch = useDispatch();
  const handleToggle = (change: string, checked: boolean) => {
    dispatch(
      handleSelectionToggle({
        ...selection,
        [change]: checked
      })
    );
  };
  const selectionArea = (title: string, value: boolean, change: string) => {
    return (
      <SelectionBoxStyled>
        <SelectionTitleStyled variant="h4">{title}</SelectionTitleStyled>
        <SwitchStyled
          checked={value}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
            handleToggle(change, event.target.checked)
          }
          onKeyDown={(event: any) => {
            if (event.key === 'Enter') {
              handleToggle(change, !event.target.checked);
            }
          }}
          inputProps={{ 'aria-label': 'Switch-Toggle', role: 'checkbox' }}
        />
      </SelectionBoxStyled>
    );
  };

  return (
    <>
      <CutOffIcon>
        <img src={exerciseIcon} alt="exerciseIcon" />
      </CutOffIcon>
      <PlaceholderGrid container width={'100%'}>
        {selection.stressFactor !== undefined &&
          selectionArea(
            'Stress Factor',
            selection.stressFactor,
            'stressFactor'
          )}
        {selection.stressFactor !== undefined && (
          <Divider sx={{ width: '100%' }} />
        )}
        {selectionArea(
          'Activity Factor/PAL',
          selection.activityFactor,
          'activityFactor'
        )}
      </PlaceholderGrid>
    </>
  );
};
